// src/lib/stores.ts
import { writable, derived } from 'svelte/store'

export interface UiState {
  theme: 'dark' | 'light'
  accentColor: string
  activeView: string
  sidebarOpen: boolean
  modalOpen: boolean
}

export const uiStore = writable<UiState>({
  theme: 'dark',
  accentColor: 'purple',
  activeView: 'dashboard',
  sidebarOpen: true,
  modalOpen: false,
})

export interface AgentData {
  groups: any[]
  runs: any[]
  providers: any[]
  settings: any[]
  leads: any[]
}

export const agentStore = writable<AgentData>({
  groups: [],
  runs: [],
  providers: [],
  settings: [],
  leads: [],
})

export const activeRuns = derived(agentStore, ($agentStore) =>
  $agentStore.runs.filter((r: any) => r.status === 'running')
)

export const totalRuns = derived(agentStore, ($agentStore) => $agentStore.runs.length)

export const providerStatus = derived(agentStore, ($agentStore) => {
  const available = $agentStore.providers.filter((p: any) => p.available).length
  return { available, total: $agentStore.providers.length }
})